import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpResponseBase,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { XsrfService } from '@shared/lib/services/xsrf.service';
import { SharedLoginConstants } from '@shared/lib/shared-login.constants';
import { LOGIN_SERVICE_URL } from '@usana/ux/sso-auth';

import { Observable, throwError } from 'rxjs';

import { catchError, tap } from 'rxjs/operators';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class XsrfInterceptor implements HttpInterceptor {
  private readonly xsrfHeaderName: string = SharedLoginConstants.XSRF_HEADER;

  constructor(
    private readonly xsrfService: XsrfService,
    @Inject(LOGIN_SERVICE_URL) private readonly loginServiceUrl: string
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const addedHeaders = {};
    if (
      this.xsrfService.exists() &&
      this.xsrfService.methodRequired(req.method) &&
      req.url.startsWith(this.loginServiceUrl)
    ) {
      addedHeaders[this.xsrfHeaderName] = this.xsrfService.load();

      req = req.clone({
        setHeaders: addedHeaders,
        withCredentials: true,
      });
    }

    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.extractXsrfHeaderIfExists(event);
        }
      }),
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          // const resp = error as HttpErrorResponse;
          this.extractXsrfHeaderIfExists(error);
        }
        return throwError(error); // rethrow
      })
    );
  }

  private extractXsrfHeaderIfExists(resp: HttpResponseBase): void {
    if (resp.headers.has(this.xsrfHeaderName)) {
      this.xsrfService.store(resp.headers.get(this.xsrfHeaderName));
    }
  }
}
